import type { QueryClient } from '@tanstack/react-query';
import { sessionGroupQueryKey, sessionGroupsQueryKey } from './keys';

export const invalidateSessionGroupQueries = (
  queryClient: QueryClient,
  groupId?: string | null
) => {
  void queryClient.invalidateQueries({ queryKey: sessionGroupsQueryKey() });

  if (groupId) {
    void queryClient.invalidateQueries({
      queryKey: sessionGroupQueryKey(groupId),
    });
  }
};
